import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';

import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';

import ProductsHome from '../../../components/Dashboard/Products/ProductsHome';
import { dashboardBreadcrumb } from '../../../data/routes';

const AdminLayout = ({
  auctionName,
  laneName,
  AuctionID,
  LaneID,
  MediaState,
  uploadStatus,
}) => {
  // console.log('products > AdminLayout', {
  //   auctionName,
  //   laneName,
  //   AuctionID,
  //   LaneID,
  //   MediaState,
  //   uploadStatus,
  // });
  const {
    AuthStore: { memberName },
    UIStore: { setHeaderText },
  } = useStores();

  let items = [];
  if (LaneID !== undefined && LaneID !== null) {
    items = [
      dashboardBreadcrumb,
      { to: '/auctions', label: 'Auctions' },
      { to: '/auction/' + AuctionID + '/lanes', label: 'Lanes' },
      {
        // to: '/auction/' + AuctionID + '/lane/' + LaneID + '/products',
        label: 'Products',
      },
    ];
  } else {
    items = [
      dashboardBreadcrumb,
      { to: '/auctions', label: 'Auctions' },

      { label: 'Products' },
    ];
  }

  const getAuctionAndLaneName = () => {
    if (!laneName) return auctionName;
    return `${auctionName} - ${laneName}`;
  };
  const auctionAndLaneName = getAuctionAndLaneName();

  useEffect(() => {
    setHeaderText(auctionAndLaneName);
  }, []);

  return (
    <Layout>
      <TopBarContainer
        // title={`Products`}
        // auctionAndLaneName={auctionAndLaneName}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={{ pathname: to, state: { auctionName } }}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        {/* <PageNavRightContainer>
                    <SelectAuctionContainer title='Views' noneselectedText='---Select Auction---' />
                </PageNavRightContainer> */}
      </PageNavContainer>
      <MainContainer>
        <ProductsHome
          AuctionID={AuctionID}
          LaneID={LaneID}
          MediaState={MediaState}
        />
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
